<div *ngIf="loadingConfig; else imageTemplate">
	<app-loading [parentHeight]="'30'" [size]="30"></app-loading>
</div>
<ng-template #imageTemplate>
	<div [ngSwitch]="uploadType">
		<div *ngSwitchCase="TYPE_ONE">
			<div [ngSwitch]="currentImageStatus">
				<div *ngSwitchCase="UP_LOAD_FAILED">
					<ng-container *ngTemplateOutlet="failedTemplate"></ng-container>
				</div>
				<div *ngSwitchCase="UP_LOADED_SUCCESSFULLY">
					<div (click)="clearImage()" class="upload-file-success-I-container">
						<div nz-row nzAlign="middle" nzJustify="space-between">
							<div>
								<div nz-row nzAlign="middle">
									<div>
										<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
											 xmlns="http://www.w3.org/2000/svg">
											<path
												d="M67.7125 34C67.7125 43.4422 63.8558 51.9534 57.6719 58.0709C51.6209 64.1218 43.2426 67.779 34 67.779C24.8238 67.779 16.4455 64.0553 10.3281 58.0709C4.14413 51.9534 0.287476 43.4422 0.287476 34C0.287476 15.3152 15.3816 0.221008 34 0.221008C52.6183 0.221008 67.7125 15.3817 67.7125 34Z"
												fill="#1EB12D" fill-opacity="0.1"/>
											<path
												d="M57.6718 16.3126V58.0709C51.6209 64.1218 43.2426 67.779 34 67.779C24.8238 67.779 16.4455 64.0553 10.3281 58.0709V16.3126H57.6718Z"
												fill="white"/>
											<path
												d="M34.8363 37.6263L25.5738 28.3638L22.4236 31.514L31.6861 40.7765L34.8363 37.6263Z"
												fill="#1EB12D"/>
											<path
												d="M42.4336 23.7592L28.6104 37.5825L31.7606 40.7327L45.5838 26.9094L42.4336 23.7592Z"
												fill="#1EB12D"/>
											<path d="M46.1019 46.4344H21.898V49.4932H46.1019V46.4344Z" fill="#D5DAE5"/>
											<path d="M46.1019 53.1503H21.898V56.209H46.1019V53.1503Z" fill="#D5DAE5"
												  opacity="0.5"/>
											<path d="M40.1838 59.9327H27.8159V62.9914H40.1838V59.9327Z" fill="#D5DAE5"
												  opacity="0.2"/>
										</svg>
									</div>
									<div>
										<div class="upload-space">
											<div class="img-success-title">Upload Successful</div>
											<div style="width: 120px">
												<div class="img-failed-des text-left">
												  	<div [title]="fileName" class="m-t-4 truncate">
														{{ fileName }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div>
								<div class="addCursor">
									<svg fill="none" height="20" viewBox="0 0 21 20" width="21"
										 xmlns="http://www.w3.org/2000/svg">
										<path
											d="M19.1795 2.9563H14.6623V2.36504C14.6623 1.06423 13.598 0 12.2972 0H8.70247C7.40166 0 6.33743 1.06423 6.33743 2.36504V2.9563H1.8202C1.29989 2.9563 0.874268 3.38193 0.874268 3.90224C0.874268 4.42255 1.29989 4.84817 1.8202 4.84817H3.14458L3.52303 16.0821C3.59397 18.1397 5.24947 19.748 7.30718 19.748H13.6928C15.7503 19.748 17.406 18.1398 17.4769 16.0821L17.8554 4.84817H19.1798C19.7001 4.84817 20.1257 4.42255 20.1257 3.90224C20.1257 3.38193 19.6999 2.9563 19.1796 2.9563H19.1795ZM8.22934 2.36504C8.22934 2.10488 8.44215 1.89208 8.7023 1.89208H12.2972C12.5574 1.89208 12.7702 2.10489 12.7702 2.36504V2.9563H8.2293L8.22934 2.36504ZM8.60778 14.8052C8.60778 15.3255 8.18216 15.7511 7.66185 15.7511C7.14154 15.7511 6.71592 15.3255 6.71592 14.8052L6.71575 7.73369C6.71575 7.21338 7.14138 6.78776 7.66169 6.78776C8.18199 6.78776 8.60762 7.21338 8.60762 7.73369L8.60778 14.8052ZM11.4458 14.8052C11.4458 15.3255 11.0202 15.7511 10.4999 15.7511C9.97955 15.7511 9.55393 15.3255 9.55393 14.8052V7.73369C9.55393 7.21338 9.97955 6.78776 10.4999 6.78776C11.0202 6.78776 11.4458 7.21338 11.4458 7.73369V14.8052ZM14.284 14.8052C14.284 15.3255 13.8583 15.7511 13.338 15.7511C12.8177 15.7511 12.3921 15.3255 12.3921 14.8052L12.3919 7.73369C12.3919 7.21338 12.8176 6.78776 13.3379 6.78776C13.8582 6.78776 14.2838 7.21338 14.2838 7.73369L14.284 14.8052Z"
											fill="#9BA6B9"/>
									</svg>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div *ngSwitchCase="UP_LOADING_IMAGE">
					<div class="upload-file-I-container">
						<div nz-row nzAlign="middle">
							<div class="flex justify-center">
								<img src="assets/images/svgs/uploading-image.svg">
							</div>
							<div>
								<div>
									<div class="img-loading-text">{{ loadingPercentage }}%</div>
								</div>
								<div>
									<nz-progress [nzPercent]="loadingPercentage" [nzShowInfo]="false"></nz-progress>
								</div>
								<div class="uploading-document" style="text-align: left !important">Uploading Document
								</div>
							</div>
						</div>
					</div>
				</div>
				<div *ngSwitchCase="DEFAULT_IMAGE_STATUS">
					<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats" style="display: none"
						   type="file"/>
					<div (click)="openFileExplorer(fileInput)" class="upload-file-I-container addCursor">
						<div class="upload-file-I-container-wrapper">
							<div class="icon flex justify-center">
								<img src="assets/images/svgs/uploading-image-II.svg">
							</div>
							<div class="description">
								<div class="mobile-upload-title">
									<div>
										{{ title || 'Tap to Upload Document' }}
									</div>
								</div>
								<div>
									<div class="sub-description">
										<div>
											<div class="mobile-upload-note">
												{{ getAllowableFiles() | uppercase }}
											</div>
										</div>
										<div>
											<div class="mobile-upload-note">Max
												Filesize: {{ getMaxFileSize() | uppercase }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngSwitchCase="TYPE_TWO">
			<div [ngSwitch]="currentImageStatus">
				<div *ngSwitchCase="UP_LOADED_SUCCESSFULLY">
					<ng-container *ngIf="variant === ImageVariant.VARIANT_1; else nonSuccessVariant">
						<div>
							<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
								   style="display: none" type="file"/>
							<div>
								<div *ngIf="!hideTitle">
									<div class="text-[14px] leading-[17px] text-black font-semibold">
										{{ title }}
									</div>
									<div class="mt-[10px]">
										<div class="text-black/60 font-normal text-[12px] leading-[15px]">View and edit
											the
											following
											information.
										</div>
									</div>
								</div>
								<div class="mt-[12px]">
									<div (click)="openFileExplorer(fileInput)"
										 class="flex gap-[7px] items-center p-3.5 min-h-[84px] bg-[#0357EE]/5 border-[1px] border-[#0357EE]/40 border-dashed rounded-[16px]">
										<div>
											<ng-container [ngSwitch]="getFileExtension(fileName)">
												<ng-container *ngSwitchCase="'.jpeg'">
													<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
												</ng-container>
												<ng-container *ngSwitchCase="'.jpg'">
													<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
												</ng-container>
												<ng-container *ngSwitchCase="'.png'">
													<ng-container *ngTemplateOutlet="pngTemplate"></ng-container>
												</ng-container>
												<ng-container *ngSwitchCase="'.pdf'">
													<img src="assets/images/svgs/upload-pdf.svg">
												</ng-container>
												<ng-container *ngSwitchDefault>
													<ng-container *ngIf="fileName else defaultTemplateV2">
														<ng-container
															*ngTemplateOutlet="defaultTemplate"></ng-container>
													</ng-container>
												</ng-container>
											</ng-container>
										</div>
										<div>
											<div class="text-[12px] text-black leading-[15px] font-medium">
												{{ fileName ? 'Document Uploaded' : 'Tap to Upload Document' }}
											</div>
											<div class="mt-[4px]">
												<div class="text-[#2E384D]/50 text-[11px] leading-[20px] font-normal">
													<ng-container *ngIf="fileName; else emptyTemplate">
														{{ fileName }}{{ refileName(fileName) }}
													</ng-container>
													<ng-template #emptyTemplate>
														<div
															class="flex max-[405px]:flex-col min-[406px]:gap-[16px] min-[406px]:items-center">
															<div>
																{{ getAllowableFiles() | uppercase }}
															</div>
															<div>
																Max Filesize: {{ getMaxFileSize() | uppercase }}
															</div>
														</div>
													</ng-template>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div *ngIf="fileName" class="mt-[10px]">
									<div nz-row nzAlign="middle" nzJustify="end">
										<div>
											<ng-container *ngIf="loadingImage; else viewTemplate">
												<app-loading [parentHeight]="'0'" [size]="20"></app-loading>
											</ng-container>
											<ng-template #viewTemplate>
												<div (click)="viewFile(fileName)"
													 class="cursor-pointer text-[14px] text-[#0361F0] leading-[20px] font-bold">
													{{viewLabel}}
												</div>
											</ng-template>
										</div>
										<div>
											<div class="ml-[32px]">
												<div (click)="openFileExplorer(fileInput)"
													 [ngClass]="{ 'opacity-5': loadingImage }"
													 class="bg-[#0361F0] px-[16px] py-[8.5px] rounded-[8px] h-[35px]">
													<div
														class="cursor-pointer text-[14px] leading-[20px] text-white font-medium">
														{{editLabel}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-template #nonSuccessVariant>
						<div>
							<div class="upload-file-success-II-container">
								<div>
									<svg class="mx-auto" fill="none" height="68" viewBox="0 0 68 68" width="68"
										 xmlns="http://www.w3.org/2000/svg">
										<path
											d="M67.7125 34C67.7125 43.4422 63.8558 51.9534 57.6719 58.0709C51.6209 64.1218 43.2426 67.779 34 67.779C24.8238 67.779 16.4455 64.0553 10.3281 58.0709C4.14413 51.9534 0.287476 43.4422 0.287476 34C0.287476 15.3152 15.3816 0.221008 34 0.221008C52.6183 0.221008 67.7125 15.3817 67.7125 34Z"
											fill="#1EB12D" fill-opacity="0.1"/>
										<path
											d="M57.6718 16.3126V58.0709C51.6209 64.1218 43.2426 67.779 34 67.779C24.8238 67.779 16.4455 64.0553 10.3281 58.0709V16.3126H57.6718Z"
											fill="white"/>
										<path
											d="M34.8363 37.6263L25.5738 28.3638L22.4236 31.514L31.6861 40.7765L34.8363 37.6263Z"
											fill="#1EB12D"/>
										<path
											d="M42.4336 23.7592L28.6104 37.5825L31.7606 40.7327L45.5838 26.9094L42.4336 23.7592Z"
											fill="#1EB12D"/>
										<path d="M46.1019 46.4344H21.898V49.4932H46.1019V46.4344Z" fill="#D5DAE5"/>
										<path d="M46.1019 53.1503H21.898V56.209H46.1019V53.1503Z" fill="#D5DAE5"
											  opacity="0.5"/>
										<path d="M40.1838 59.9327H27.8159V62.9914H40.1838V59.9327Z" fill="#D5DAE5"
											  opacity="0.2"/>
									</svg>
								</div>
								<div class="m-t-8">
									<div class="img-success-title">Upload Successful</div>
								</div>
								<div class="m-t-4">
									<div class="img-failed-des">
										{{ fileName }}
									</div>
								</div>
							</div>
						</div>
						<div class="m-t-22">
							<div (click)="clearImage()" class="addCursor">
								<div nz-row nzAlign="middle" nzJustify="center">
									<div>
										<svg fill="none" height="20" viewBox="0 0 21 20" width="21"
											 xmlns="http://www.w3.org/2000/svg">
											<path
												d="M19.1795 2.9563H14.6623V2.36504C14.6623 1.06423 13.598 0 12.2972 0H8.70247C7.40166 0 6.33743 1.06423 6.33743 2.36504V2.9563H1.8202C1.29989 2.9563 0.874268 3.38193 0.874268 3.90224C0.874268 4.42255 1.29989 4.84817 1.8202 4.84817H3.14458L3.52303 16.0821C3.59397 18.1397 5.24947 19.748 7.30718 19.748H13.6928C15.7503 19.748 17.406 18.1398 17.4769 16.0821L17.8554 4.84817H19.1798C19.7001 4.84817 20.1257 4.42255 20.1257 3.90224C20.1257 3.38193 19.6999 2.9563 19.1796 2.9563H19.1795ZM8.22934 2.36504C8.22934 2.10488 8.44215 1.89208 8.7023 1.89208H12.2972C12.5574 1.89208 12.7702 2.10489 12.7702 2.36504V2.9563H8.2293L8.22934 2.36504ZM8.60778 14.8052C8.60778 15.3255 8.18216 15.7511 7.66185 15.7511C7.14154 15.7511 6.71592 15.3255 6.71592 14.8052L6.71575 7.73369C6.71575 7.21338 7.14138 6.78776 7.66169 6.78776C8.18199 6.78776 8.60762 7.21338 8.60762 7.73369L8.60778 14.8052ZM11.4458 14.8052C11.4458 15.3255 11.0202 15.7511 10.4999 15.7511C9.97955 15.7511 9.55393 15.3255 9.55393 14.8052V7.73369C9.55393 7.21338 9.97955 6.78776 10.4999 6.78776C11.0202 6.78776 11.4458 7.21338 11.4458 7.73369V14.8052ZM14.284 14.8052C14.284 15.3255 13.8583 15.7511 13.338 15.7511C12.8177 15.7511 12.3921 15.3255 12.3921 14.8052L12.3919 7.73369C12.3919 7.21338 12.8176 6.78776 13.3379 6.78776C13.8582 6.78776 14.2838 7.21338 14.2838 7.73369L14.284 14.8052Z"
												fill="#9BA6B9"/>
										</svg>
									</div>
									<div>
										<div class="clear-upload">Clear Upload</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
				</div>
				<div *ngSwitchCase="UP_LOAD_FAILED">
					<ng-container *ngIf="variant === ImageVariant.VARIANT_1; else nonFailedVariant">
						<div class="image-view-edit-failed-wrapper">
							<div class="title">
								{{ title }}
							</div>
							<div class="m-t-10">
								<div class="sub-title">View and edit the following information.</div>
							</div>
							<div class="m-t-12">
								<ng-container *ngTemplateOutlet="failedTemplate"></ng-container>
							</div>
						</div>
					</ng-container>
					<ng-template #nonFailedVariant>
						<div>
							<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
								   style="display: none" type="file"/>
							<div (click)="openFileExplorer(fileInput)" class="upload-file-failure-II-container">
								<div>
									<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
										 xmlns="http://www.w3.org/2000/svg">
										<path
											d="M67.7125 34C67.7125 43.4422 63.8558 51.9534 57.6719 58.0709C51.6209 64.1218 43.2426 67.779 34 67.779C24.8238 67.779 16.4455 64.0553 10.3281 58.0709C4.14413 51.9534 0.287476 43.4422 0.287476 34C0.287476 15.3152 15.3816 0.221008 34 0.221008C52.6183 0.221008 67.7125 15.3817 67.7125 34Z"
											fill="#E94444" fill-opacity="0.1"/>
										<path
											d="M57.6719 16.3126V58.0709C51.6209 64.1218 43.2427 67.779 34 67.779C24.8238 67.779 16.4456 64.0553 10.3281 58.0709V16.3126H57.6719Z"
											fill="white"/>
										<path
											d="M41.2124 37.3885L28.8239 25L26.0001 27.8238L38.3886 40.2123L41.2124 37.3885Z"
											fill="#E94444"/>
										<path
											d="M38.7793 25.0992L26.3883 37.4902L29.2121 40.314L41.6031 27.923L38.7793 25.0992Z"
											fill="#E94444"/>
										<path d="M46.1019 46.4344H21.8981V49.4932H46.1019V46.4344Z" fill="#D5DAE5"/>
										<path d="M46.1019 53.1503H21.8981V56.209H46.1019V53.1503Z" fill="#D5DAE5"
											  opacity="0.5"/>
										<path d="M40.1838 59.9327H27.8159V62.9914H40.1838V59.9327Z" fill="#D5DAE5"
											  opacity="0.2"/>
									</svg>
								</div>
								<div class="m-t-8">
									<div class="img-failed-title">Failed to Upload</div>
								</div>
								<div class="m-t-4">
									<div class="img-failed-des">
										{{ error }}
									</div>
								</div>
							</div>
						</div>
						<div class="m-t-22">
							<div (click)="currentImageStatus=DEFAULT_IMAGE_STATUS" class="addCursor">
								<div nz-row nzAlign="middle" nzJustify="center">
									<div>
										<svg fill="none" height="24" viewBox="0 0 24 24" width="24"
											 xmlns="http://www.w3.org/2000/svg">
											<path
												d="M11.995 4.00001C7.8362 3.99432 4.36664 7.17599 4.01299 11.3197C3.65933 15.4634 6.53955 19.187 10.6391 19.8862C14.7387 20.5853 18.6903 18.0267 19.73 14H17.649C16.6318 16.8771 13.617 18.5324 10.6434 17.8465C7.66989 17.1605 5.68488 14.3519 6.03079 11.3199C6.3767 8.28792 8.94332 5.99856 11.995 6.00001C13.5845 6.00234 15.1064 6.64379 16.218 7.78002L13 11H20V4.00001L17.649 6.35002C16.1527 4.84464 14.1175 3.99873 11.995 4.00001Z"
												fill="#0361F0"/>
										</svg>
									</div>
									<div>
										<div class="img-retry">Retry</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
				</div>
				<div *ngSwitchCase="UP_LOADING_IMAGE">
					<div class="upload-file-II-container">
						<div class="m-t-10 flex justify-center">
							<img src="assets/images/svgs/uploading-image-iii.svg">
						</div>
						<div>
							<div class="img-loading-text">{{ loadingPercentage }}%</div>
						</div>
						<div>
							<nz-progress [nzPercent]="loadingPercentage" [nzShowInfo]="false"></nz-progress>
						</div>
						<div class="uploading-document">Uploading Document</div>
					</div>
				</div>
				<div *ngSwitchCase="DEFAULT_IMAGE_STATUS">
					<div class="upload-file-II-container" id="dropZone">
						<div class="flex justify-center">
							<img src="assets/images/svgs/drag-and-drop.svg">
						</div>
						<div class="m-t-8">
							<span class="upload-file-II-note"> {{ defaultFileText }} </span>
						</div>
						<div class="m-t-8">
							<span *ngIf="!fileName" class="upload-file-II-sub-note">{{fileTypeLabel}}</span>
							<span *ngIf="!fileName" class="m-l-16 upload-file-II-sub-note">
								Max Filesize: {{getMaxFileSize() | uppercase}}
							</span>
							<span *ngIf="fileName" class="custom-image-subtitle">{{ fileName }}</span>
						</div>
						<div class="m-t-12">
							<nz-divider class="upload-file-II-note-OR" nzText="OR"></nz-divider>
						</div>
						<div class="m-t-12">
							<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
								   style="display: none" type="file"/>
							<button (click)="openFileExplorer(fileInput)" class="btn btn-primary" nz-button
									style="min-width: 134px">
								Browse Files
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngSwitchCase="TYPE_THREE">
			<ng-container [ngSwitch]="currentImageStatus">
				<ng-container *ngSwitchCase="UP_LOAD_FAILED">
					<div class="image-view-edit-failed-wrapper">
						<div class="title">
							{{ title }}
						</div>
						<div class="m-t-10">
							<div class="sub-title">View and edit the following information.</div>
						</div>
						<div class="m-t-12">
							<ng-container *ngTemplateOutlet="failedTemplate"></ng-container>
						</div>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="UP_LOADING_IMAGE">
					<div class="upload-file-I-container">
						<div class="flex">
							<div class="flex justify-center">
								<img src="assets/images/svgs/uploading-image.svg">
							</div>
							<div style="width: 65%">
								<div>
									<div class="img-loading-text">{{ loadingPercentage }}%</div>
								</div>
								<div>
									<nz-progress [nzPercent]="loadingPercentage" [nzShowInfo]="false"></nz-progress>
								</div>
								<div class="uploading-document" style="text-align: left !important">Uploading Document
								</div>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngSwitchDefault>
					<div>
						<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
							   style="display: none" type="file"/>
						<div class="image-view-edit-wrapper image-view-edit-active">
							<div class="title">
								{{ title }}
							</div>
							<div class="mt-[10px]">
								<div class="sub-title">View and edit the following information.</div>
							</div>
							<div class="mt-[12px]">
								<div (click)="openFileExplorer(fileInput)" class="image-box">
									<div [ngClass]="{'image-container-v2':fileName}" class="flex items-center">
										<div>
											<ng-container
												*ngTemplateOutlet="fileTypeTemplate; context:{fileType: getFileExtension(fileName)}">
											</ng-container>
										</div>
										<div>
											<div class="label">
												{{ fileName ? 'File Uploaded' : 'Upload File' }}
											</div>
											<div class="m-t-4">
												<div class="description">
													<ng-container *ngIf="fileName; else emptyTemplate">
														{{ fileName }}{{ refileName(fileName) }}
													</ng-container>
													<ng-template #emptyTemplate>
														<div>
															<div>
																<div class="empty-text">
																	{{ getAllowableFiles() | uppercase }}
																</div>
															</div>
															<div>
																<div class="empty-text">Max
																	Filesize: {{ getMaxFileSize() | uppercase }}</div>
															</div>
														</div>
													</ng-template>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div *ngIf="fileName" class="mt-[10px]">
								<div nz-row nzAlign="middle" nzJustify="end">
									<div>
										<ng-container *ngIf="loadingImage; else viewTemplate">
											<app-loading [parentHeight]="'0'" [size]="20"></app-loading>
										</ng-container>
										<ng-template #viewTemplate>
											<div (click)="viewFile(fileName)"
												 class="view-btn addCursor">{{viewLabel}}</div>
										</ng-template>
									</div>
									<div>
										<div class="m-l-32">
											<div (click)="openFileExplorer(fileInput)"
												 [ngClass]="{ 'opacity-5': loadingImage }" class="edit-btn">
												<div class="btn-text addCursor">{{editLabel}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<div *ngSwitchCase="TYPE_FOUR">
			<ng-container [ngSwitch]="currentImageStatus">
				<ng-container *ngSwitchCase="UP_LOAD_FAILED">
					<div class="image-view-edit-failed-wrapper">
						<div class="title">
							{{ title }}
						</div>
						<div class="m-t-10">
							<div class="sub-title">View and edit the following information.</div>
						</div>
						<div class="m-t-12">
							<ng-container *ngTemplateOutlet="failedTemplate"></ng-container>
						</div>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="UP_LOADING_IMAGE">
					<div class="upload-file-I-container">
						<div class="flex">
							<div class="flex justify-center">
								<img src="assets/images/svgs/uploading-image.svg">
							</div>
							<div style="width: 65%">
								<div>
									<div class="img-loading-text">{{ loadingPercentage }}%</div>
								</div>
								<div>
									<nz-progress [nzPercent]="loadingPercentage" [nzShowInfo]="false"></nz-progress>
								</div>
								<div class="uploading-document" style="text-align: left !important">Uploading Document
								</div>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngSwitchDefault>
					<div>
						<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
							   style="display: none" type="file"/>
						<div>
							<div *ngIf="!hideTitle">
								<div class="text-[14px] leading-[17px] text-black font-semibold">
									{{ title }}
								</div>
								<div class="mt-[10px]">
									<div class="text-black/60 font-normal text-[12px] leading-[15px]">View and edit the
										following
										information.
									</div>
								</div>
							</div>
							<div class="mt-[12px]">
								<div (click)="openFileExplorer(fileInput)"
									 class="flex gap-[7px] items-center p-3.5 min-h-[84px] bg-[#0357EE]/5 border-[1px] border-[#0357EE]/40 border-dashed rounded-[16px]">
									<div>
										<ng-container [ngSwitch]="getFileExtension(fileName)">
											<ng-container *ngSwitchCase="'.jpeg'">
												<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.jpg'">
												<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.png'">
												<ng-container *ngTemplateOutlet="pngTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.pdf'">
												<img src="assets/images/svgs/upload-pdf.svg">
											</ng-container>
											<ng-container *ngSwitchDefault>
												<ng-container *ngIf="fileName else defaultTemplateV2">
													<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
												</ng-container>
											</ng-container>
										</ng-container>
									</div>
									<div>
										<div class="text-[12px] text-black leading-[15px] font-medium">
											{{ fileName ? 'Document Uploaded' : 'Tap to Upload Document' }}
										</div>
										<div class="mt-[4px]">
											<div class="text-[#2E384D]/50 text-[11px] leading-[20px] font-normal">
												<ng-container *ngIf="fileName; else emptyTemplate">
													{{ fileName }}{{ refileName(fileName) }}
												</ng-container>
												<ng-template #emptyTemplate>
													<div
														class="flex max-[405px]:flex-col min-[406px]:gap-[16px] min-[406px]:items-center">
														<div>
															{{ getAllowableFiles() | uppercase }}
														</div>
														<div>
															Max Filesize: {{ getMaxFileSize() | uppercase }}
														</div>
													</div>
												</ng-template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div *ngIf="fileName" class="mt-[10px]">
								<div nz-row nzAlign="middle" nzJustify="end">
									<div>
										<ng-container *ngIf="loadingImage; else viewTemplate">
											<app-loading [parentHeight]="'0'" [size]="20"></app-loading>
										</ng-container>
										<ng-template #viewTemplate>
											<div (click)="viewFile(fileName)"
												 class="cursor-pointer text-[14px] text-[#0361F0] leading-[20px] font-bold">
												{{viewLabel}}
											</div>
										</ng-template>
									</div>
									<div>
										<div class="ml-[32px]">
											<div (click)="openFileExplorer(fileInput)"
												 [ngClass]="{ 'opacity-5': loadingImage }"
												 class="bg-[#0361F0] px-[16px] py-[8.5px] rounded-[8px] h-[35px]">
												<div
													class="cursor-pointer text-[14px] leading-[20px] text-white font-medium">
													{{editLabel}}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<div *ngSwitchCase="TYPE_FIVE">
			<ng-container [ngSwitch]="currentImageStatus">
				<ng-container *ngSwitchCase="UP_LOAD_FAILED">
					<div class="image-view-edit-failed-wrapper !border-none !p-0">
						<div *ngIf="!hideTitle">
							<div class="title">
								{{ title }}
							</div>
							<div class="m-t-10">
								<div class="sub-title">View and edit the following information.</div>
							</div>
						</div>
						<div class="m-t-12">
							<ng-container *ngTemplateOutlet="failedTemplate"></ng-container>
						</div>
					</div>
				</ng-container>
				<div *ngSwitchCase="UP_LOADING_IMAGE">
					<div class="upload-file-I-container">
						<div nz-row nzAlign="middle">
							<div class="flex justify-center">
								<img src="assets/images/svgs/uploading-image.svg">
							</div>
							<div style="width: 65%">
								<div>
									<div class="img-loading-text">{{ loadingPercentage }}%</div>
								</div>
								<div>
									<nz-progress [nzPercent]="loadingPercentage" [nzShowInfo]="false"></nz-progress>
								</div>
								<div class="uploading-document" style="text-align: left !important">Uploading Document
								</div>
							</div>
						</div>
					</div>
				</div>
				<ng-container *ngSwitchDefault>
					<div>
						<div>
							<div *ngIf="!hideTitle">
								<div class="text-[14px] title-v5 leading-[17px] text-black font-semibold">
									{{ title }}
								</div>
								<div class="mt-[10px]">
									<div class="text-black/60 font-normal text-[12px] leading-[15px]">View and edit the
										following
										information.
									</div>
								</div>
							</div>
							<div class="mt-[12px]">
								<div *ngIf="fileName else emptyTemplateV5">
									<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
										   style="display: none" type="file"/>
									<div
										class="border-[#0361F0] bg-white min-h-[89px] box-border border-dashed border-[1px] rounded-[16px]">
										<div class="document-v5">
											<div *ngIf="isPdf else documentSample">
												<pdf-viewer
													[autoresize]="true"
													[external-link-target]="'blank'"
													[fit-to-page]="false"
													[original-size]="false"
													[render-text]="true"
													[rotation]="0"
													[show-all]="true"
													[show-borders]="false"
													[src]="documentV2"
													[stick-to-page]="false"
													[zoom-scale]="'page-width'"
													[zoom]="1"
													style="height: 89px;"
												></pdf-viewer>
											</div>
										</div>
									</div>
									<div class="mt-[17.5px]">
										<div (click)="openFileExplorer(fileInput)"
											 class="cursor-pointer text-end text-[#0361F0] font-bold text-[14px] leading-[20px]">
											Re-Upload
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<div *ngSwitchCase="TYPE_SIX">
			<ng-container [ngSwitch]="currentImageStatus">
				<ng-container *ngSwitchCase="UP_LOAD_FAILED">
					<div class="image-view-edit-failed-wrapper !border-none !p-0">
						<div *ngIf="!hideTitle">
							<div class="title">
								{{ title }}
							</div>
							<div class="m-t-10">
								<div class="sub-title">View and edit the following information.</div>
							</div>
						</div>
						<div class="m-t-12">
							<ng-container *ngTemplateOutlet="failedTemplate"></ng-container>
						</div>
					</div>
				</ng-container>
				<div *ngSwitchCase="UP_LOADING_IMAGE">
					<div class="upload-file-I-container">
						<div nz-row nzAlign="middle">
							<div class="flex justify-center">
								<img src="assets/images/svgs/uploading-image.svg">
							</div>
							<div class="flex-1 max-w-[65%]">
								<div>
									<div class="img-loading-text">{{ loadingPercentage }}%</div>
								</div>
								<div>
									<nz-progress [nzPercent]="loadingPercentage" [nzShowInfo]="false"></nz-progress>
								</div>
								<div class="uploading-document" style="text-align: left !important">Uploading Document
								</div>
							</div>
						</div>
					</div>
				</div>
				<ng-container *ngSwitchDefault>
					<div>
						<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
							   style="display: none" type="file"/>
						<div>
							<div *ngIf="!hideTitle">
								<div class="text-[14px] leading-[17px] text-black font-semibold">
									{{ title }}
								</div>
								<div class="mt-[10px]">
									<div class="text-black/60 font-normal text-[12px] leading-[15px]">View and edit the
										following
										information.
									</div>
								</div>
							</div>
							<div class="mt-[12px]">
								<div (click)="openFileExplorer(fileInput)"
									 class="flex gap-[3px] items-center py-3.5 pl-2 pr-3.5 min-h-[84px] bg-[#0357EE]/5 border-[1px] border-[#0357EE]/40 border-dashed rounded-[16px]">
									<div>
										<ng-container [ngSwitch]="getFileExtension(fileName)">
											<ng-container *ngSwitchCase="'.jpeg'">
												<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.jpg'">
												<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.png'">
												<ng-container *ngTemplateOutlet="pngTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.pdf'">
												<img src="assets/images/svgs/upload-pdf.svg">
											</ng-container>
											<ng-container *ngSwitchDefault>
												<ng-container *ngIf="fileName else defaultTemplateV6">
													<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
												</ng-container>
											</ng-container>
										</ng-container>
									</div>
									<div class="max-w-full">
										<div class="text-[12px] text-black leading-[15px] font-medium">
											{{ fileName ? 'Document Uploaded' : 'Tap to Upload Document' }}
										</div>
										<div class="mt-[4px]">
											<div class="text-[#2E384D]/50 text-[10px] leading-[18px] font-normal">
												<ng-container *ngIf="fileName; else emptyTemplate">
													<span class="word-wrap">
														{{ fileName }}{{ refileName(fileName) }}
													</span>
												</ng-container>
												<ng-template #emptyTemplate>
													<div
														class="flex max-[405px]:flex-col min-[406px]:gap-[16px] min-[406px]:items-center">
														<div class="keep-all-word">
															{{ getAllowableFiles() | uppercase }}
														</div>
														<div class="keep-all-word">
															Max Filesize: {{ getMaxFileSize() | uppercase }}
														</div>
													</div>
												</ng-template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div *ngIf="fileName" class="mt-[10px]">
								<div nz-row nzAlign="middle" nzJustify="end">
									<div>
										<ng-container *ngIf="loadingImage; else viewTemplate">
											<app-loading [parentHeight]="'0'" [size]="20"></app-loading>
										</ng-container>
										<ng-template #viewTemplate>
											<div (click)="viewFile(fileName)"
												 class="cursor-pointer text-[14px] text-[#0361F0] leading-[20px] font-bold">
												View
											</div>
										</ng-template>
									</div>
									<div>
										<div class="ml-[32px]">
											<div (click)="openFileExplorer(fileInput)"
												 [ngClass]="{ 'opacity-5': loadingImage }"
												 class="bg-[#0361F0] px-[16px] py-[8.5px] rounded-[8px] h-[35px]">
												<div
													class="cursor-pointer text-[14px] leading-[20px] text-white font-medium">
													Edit
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<div *ngSwitchCase="TYPE_SEVEN">
			<ng-container [ngSwitch]="currentImageStatus">
				<ng-container *ngSwitchCase="UP_LOAD_FAILED">
					<div class="image-view-edit-failed-wrapper !border-none !p-0">
						<div *ngIf="!hideTitle">
							<div class="title mb-[10px]">
								{{ title }}
							</div>
						</div>
						<div class="m-t-12">
							<ng-container *ngTemplateOutlet="failedTemplate"></ng-container>
						</div>
					</div>
				</ng-container>
				<div *ngSwitchCase="UP_LOADING_IMAGE">
					<div class="upload-file-I-container">
						<div nz-row nzAlign="middle">
							<div class="flex justify-center">
								<img src="assets/images/svgs/uploading-image.svg">
							</div>
							<div style="width: 65%">
								<div>
									<div class="img-loading-text">{{ loadingPercentage }}%</div>
								</div>
								<div>
									<nz-progress [nzPercent]="loadingPercentage" [nzShowInfo]="false"></nz-progress>
								</div>
								<div class="uploading-document" style="text-align: left !important">Uploading Document
								</div>
							</div>
						</div>
					</div>
				</div>
				<ng-container *ngSwitchDefault>
					<div>
						<input #fileInput (change)="onFileChange($event)" [accept]="allowedFormats"
							   style="display: none" type="file"/>
						<div>
							<div *ngIf="!hideTitle">
								<div class="text-[14px] leading-[17px] text-black font-semibold mb-[10px]">
									{{ title }}
								</div>
							</div>
							<div class="mt-[12px]">
								<div (click)="openFileExplorer(fileInput)"
									 class="flex gap-[7px] items-center p-3.5 min-h-[84px] bg-[#0357EE]/5 border-[1px] border-[#0357EE]/40 border-dashed rounded-[16px]">
									<div>
										<ng-container [ngSwitch]="getFileExtension(fileName)">
											<ng-container *ngSwitchCase="'.jpeg'">
												<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.jpg'">
												<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.png'">
												<ng-container *ngTemplateOutlet="pngTemplate"></ng-container>
											</ng-container>
											<ng-container *ngSwitchCase="'.pdf'">
												<img src="assets/images/svgs/upload-pdf.svg">
											</ng-container>
											<ng-container *ngSwitchDefault>
												<ng-container *ngIf="fileName else defaultTemplateV2">
													<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
												</ng-container>
											</ng-container>
										</ng-container>
									</div>
									<div>
										<div class="text-[12px] text-black leading-[15px] font-medium">
											{{ fileName ? 'Document Uploaded' : 'Tap to Upload Document' }}
										</div>
										<div class="mt-[4px]">
											<div class="text-[#2E384D]/50 text-[11px] leading-[20px] font-normal">
												<ng-container *ngIf="fileName; else emptyTemplate">
													{{ fileName }}{{ refileName(fileName) }}
												</ng-container>
												<ng-template #emptyTemplate>
													<div
														class="flex max-[405px]:flex-col min-[406px]:gap-[16px] min-[406px]:items-center">
														<div>
															{{ getAllowableFiles() | uppercase }}
														</div>
														<div>
															Max Filesize: {{ getMaxFileSize() | uppercase }}
														</div>
													</div>
												</ng-template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div *ngIf="fileName" class="mt-[10px]">
								<div nz-row nzAlign="middle" nzJustify="end">
									<div>
										<ng-container *ngIf="loadingImage; else viewTemplate">
											<app-loading [parentHeight]="'0'" [size]="20"></app-loading>
										</ng-container>
										<ng-template #viewTemplate>
											<div (click)="viewFile(fileName)"
												 class="cursor-pointer text-[14px] text-[#0361F0] leading-[20px] font-bold">
												View
											</div>
										</ng-template>
									</div>
									<div>
										<div class="ml-[32px]">
											<div (click)="openFileExplorer(fileInput)"
												 [ngClass]="{ 'opacity-5': loadingImage }"
												 class="bg-[#0361F0] px-[16px] py-[8.5px] rounded-[8px] h-[35px]">
												<div
													class="cursor-pointer text-[14px] leading-[20px] text-white font-medium">
													Edit
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
</ng-template>
<ng-template #documentSample>
	<div class="p-[10px]">
		<img [src]='documentV2' class="mx-auto max-w-[90%]" height="89" id="refDocument"/>
	</div>
</ng-template>
<ng-template #pngTemplate>
	<img src="assets/images/svgs/upload-png.svg">
</ng-template>
<ng-template #defaultTemplateV2>
	<img src="assets/images/svgs/default-upload-image-v2.svg">
</ng-template>
<ng-template #defaultTemplateV6>
	<img src="assets/images/svgs/default-upload-image-v6.svg">
</ng-template>
<ng-template #defaultTemplate>
	<ng-container *ngIf="fileName else filledIcon">
		<img src="assets/images/svgs/uploaded-document-icon.svg">
	</ng-container>
</ng-template>
<ng-template #filledIcon>
	<img src="assets/images/svgs/default-upload-image-v2.svg">
</ng-template>
<ng-template #jpegTemplate>
	<img src="assets/images/svgs/upload-jpeg.svg">
</ng-template>
<ng-template #failedTemplate>
	<input #fileInputII (change)="onFileChange($event)" [accept]="allowedFormats" style="display: none" type="file"/>
	<div (click)="openFileExplorer(fileInputII)" class="upload-file-failed-I-container">
		<div nz-row nzAlign="middle" nzJustify="space-between">
			<div class="flex-1">
				<div nz-row nzAlign="middle">
					<div class="flex flex-wrap">
						<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M67.7125 34C67.7125 43.4422 63.8558 51.9534 57.6719 58.0709C51.6209 64.1218 43.2426 67.779 34 67.779C24.8238 67.779 16.4455 64.0553 10.3281 58.0709C4.14413 51.9534 0.287476 43.4422 0.287476 34C0.287476 15.3152 15.3816 0.221008 34 0.221008C52.6183 0.221008 67.7125 15.3817 67.7125 34Z"
								fill="#E94444" fill-opacity="0.1"/>
							<path
								d="M57.6719 16.3126V58.0709C51.6209 64.1218 43.2427 67.779 34 67.779C24.8238 67.779 16.4456 64.0553 10.3281 58.0709V16.3126H57.6719Z"
								fill="white"/>
							<path d="M41.2124 37.3885L28.8239 25L26.0001 27.8238L38.3886 40.2123L41.2124 37.3885Z"
								  fill="#E94444"/>
							<path d="M38.7793 25.0992L26.3883 37.4902L29.2121 40.314L41.6031 27.923L38.7793 25.0992Z"
								  fill="#E94444"/>
							<path d="M46.1019 46.4344H21.8981V49.4932H46.1019V46.4344Z" fill="#D5DAE5"/>
							<path d="M46.1019 53.1503H21.8981V56.209H46.1019V53.1503Z" fill="#D5DAE5" opacity="0.5"/>
							<path d="M40.1838 59.9327H27.8159V62.9914H40.1838V59.9327Z" fill="#D5DAE5" opacity="0.2"/>
						</svg>
					</div>
					<div class="flex-1">
						<div class="upload-space">
							<div class="img-success-title text-left" style="color: rgba(0, 0, 0, 0.9) !important">Failed
								to
								Upload
							</div>
							<div>
								<div class="img-failed-des text-left">
									<div class="mt-[4px] max-w-[115px]">{{error}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div (click)="currentImageStatus=DEFAULT_IMAGE_STATUS">
				<div class="addCursor img-failed-title">Retry</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #emptyTemplateV5>
	<input #fileInputV5 (change)="onFileChange($event)" [accept]="allowedFormats"
		   style="display: none" type="file"/>
	<div (click)="openFileExplorer(fileInputV5)"
		 class="flex gap-[7px] items-center p-3.5 min-h-[84px] bg-[#0357EE]/5 border-[1px] border-[#0357EE]/40 border-dashed rounded-[16px]">
		<div>
			<ng-container [ngSwitch]="getFileExtension(fileName)">
				<ng-container *ngSwitchCase="'.jpeg'">
					<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'.jpg'">
					<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'.png'">
					<ng-container *ngTemplateOutlet="pngTemplate"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'.pdf'">
					<img src="assets/images/svgs/upload-pdf.svg">
				</ng-container>
				<ng-container *ngSwitchDefault>
					<ng-container *ngIf="fileName else defaultTemplateV2">
						<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
					</ng-container>
				</ng-container>
			</ng-container>
		</div>
		<div>
			<div class="text-[12px] text-black leading-[15px] font-medium">
				{{ fileName ? 'Document Uploaded' : 'Tap to Upload Document' }}
			</div>
			<div class="mt-[4px]">
				<div class="text-[#2E384D]/50 text-[11px] leading-[20px] font-normal">
					<ng-container *ngIf="fileName; else emptyTemplate">
						{{ fileName }}{{ refileName(fileName) }}
					</ng-container>
					<ng-template #emptyTemplate>
						<div
							class="flex max-[480px]:gap-[0px] max-[480px]:flex-col min-[481px]:flex-row min-[481px]:gap-[16px] min-[481px]:items-center">
							<div class="mr-1">
								{{ getAllowableFiles() | uppercase }}
							</div>
							<div>
								Max File size: {{ getMaxFileSize() | uppercase }}
							</div>
						</div>
					</ng-template>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #fileTypeTemplate let-fileType="fileType">
	<ng-container [ngSwitch]="fileType">
		<ng-container *ngSwitchCase="'.jpeg'">
			<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="'.jpg'">
			<ng-container *ngTemplateOutlet="jpegTemplate"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="'.png'">
			<ng-container *ngTemplateOutlet="pngTemplate"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="'.pdf'">
			<img src="assets/images/svgs/upload-pdf.svg">
		</ng-container>
		<ng-container *ngSwitchDefault>
			<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
		</ng-container>
	</ng-container>
</ng-template>
